// ======================================================================
// File Name       : DistributionServiceSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';
import PaginationCustom from '../Pagination';
import { DISTRIBUTION_TYPE, CONTENT_DISTRIBUTION_TYPE, COURSE } from '../../constants/ContentDistributionConstant';
import CustomButton from '../button/CustomButton';
import * as Path from '../../constants/PathConstants';
import * as ICON from '../../constants/IconConstants';
import CustomLink from '../button/CustomLink';

const DistributionServiceSearch = ({
    serviceName,
    enterpriseName,
    distributionType,
    contentDistributionType,
    recordNum,
    startPosition,
    handleInputChange,
    getStartEndData,
    onSearchBtnClick,
    doSyncContents,
    doSyncCourses,
  }) => (
    <div>
      <Col sm={12} className="padding-right-clear">
        <Form onSubmit={(e) => {e.preventDefault();onSearchBtnClick()}} className='form-horizontal'>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>配布先サービス名</Col>
            <Col sm={7}>
              <FormControl
                type="text"
                name="serviceName"
                onChange={handleInputChange}
                value={serviceName}
                maxLength="256"
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>配布先企業名</Col>
            <Col sm={7}>
              <FormControl
                type="text"
                name="enterpriseName"
                onChange={handleInputChange}
                value={enterpriseName}
                maxLength="256"
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>配布種別</Col>
            <Col sm={7}>
              <Form.Select
                name="distributionType"
                value={distributionType}
                onChange={handleInputChange}
              >
                <option value={null} />
                {DISTRIBUTION_TYPE.map(item =>
                  (<option key={item.value} value={item.value}>
                    {item.name}
                  </option>))
                }
              </Form.Select>
            </Col>
          </Form.Group>
          <Form.Group className={parseInt(distributionType, 10) !== COURSE && !isNaN(parseInt(distributionType, 10)) ? 'form-info' : 'hidden'}>
            <Col as={Form.Label} sm={3}>コンテンツ種別</Col>
            <Col sm={7}>
              <Form.Select
                name="contentDistributionType"
                value={contentDistributionType}
                onChange={handleInputChange}
              >
                <option value={null} />
                {CONTENT_DISTRIBUTION_TYPE.map(item => <option key={item.value} value={item.value}>{item.name}</option>)}
              </Form.Select>
            </Col>
          </Form.Group>
          <Form.Group className="margin-top-20 text-center form-group">
            <Col sm={12}>
              {/* <Button bsStyle="primary" className="btn-96" type="submit">search</Button> */}
              <CustomButton
                btnStyle="btn btn-primary btn-96"
                type="submit"
                text="検索"
                iconClass="bi bi-search"
              />
            </Col>
          </Form.Group>
        <Form.Group>
          <Col sm={12} className="padding-left-right-clear">
            <Col sm={9} className="padding-left-right-clear inline-flex">
              <CustomLink
                className="margin-right-7 btn-register margin-right-10"
                to={Path.CONTENT_DISTRIBUTION_REGISTER}
                text="新規登録"
                icon={ICON.REGIST}
              />
              <CustomLink
                className="margin-right-7 btn-csv-import margin-right-10"
                to={Path.CONTENT_DISTRIBUTION_IMPORT}
                text="コンテンツ一括配布"
                icon={ICON.IMPORT}
              />
              <CustomLink
                className="margin-right-7 btn-csv-import"
                to={Path.COURSE_DISTRIBUTION_IMPORT}
                text="コース一括配布"
                icon={ICON.IMPORT}
              />
            </Col>
          </Col>
          {/* Step 11.0.0 START */}
          <Col sm={12} className="padding-left-right-clear margin-top-10 margin-bottom-15">
            <Col sm={9} className="padding-left-right-clear inline-flex">
              <CustomLink
                className="margin-right-7 btn-csv-import margin-right-10"
                text="コンテンツ変更内容再配信"
                onClick={doSyncContents}
              />
              <CustomLink
                className="margin-right-7 btn-csv-import margin-right-10"
                text="コース変更内容再配信"
                onClick={doSyncCourses}
              />
          </Col>
          {/* Step 11.0.0 END */}
          </Col>
        </Form.Group>
        </Form>
      </Col>
    </div>
  );

export default DistributionServiceSearch;
